module.exports = __webpack_public_path__ + "img/Icons for SPIM Sidebar-58.0bedc0bf.svg";